import { Component} from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { ToastProvider } from '../../providers/toast/toast';
import { ExtraProvider } from '../../providers/extra/extra';
import { VehicleAccessLogPage } from '../../pages/vehicle-access-log/vehicle-access-log';
import { VehicleProvider } from '../../providers/vehicle/vehicle';
import { SmartLockProvider } from '../../providers/smart-lock/smart-lock';
import { TranslateService } from '@ngx-translate/core';
import { VehicleTagPage } from '../vehicle-tag/vehicle-tag';
import { AddVehiclePage } from '../add-vehicle/add-vehicle';

@IonicPage()
@Component({
  selector: 'page-vehicle-detail',
  templateUrl: 'vehicle-detail.html',
})
export class VehicleDetailPage {

  showData = false;//remove
  // presentVehicle=[];
  // absentVehicle=[];
  // vehicles =[];
  isNotifyEnabled = false;
  vehicle : any;
  userId : any;
  providers : any;
  provider : any;
  vehSmartLocks =[];
  viewAccordion = {detail:true,tag:false,logs:false}

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private toast: ToastProvider,
    private extra: ExtraProvider,
    private vehicleProvider: VehicleProvider,
    private smartLockProvider: SmartLockProvider,
    public alertCtrl: AlertController
    ){
      this.vehicle = this.navParams.get("data"); 
      this.providers = this.navParams.get("setup");
      this.provider = null; 
      if(this.providers && this.vehicle && this.vehicle.provider){
        this.provider = this.findTagSetup(this.vehicle, this.providers)
      }
      this.getSmartLocksData();
      this.isNotifyEnabled = this.vehicle.is_subscribed;
      }  
      
  findTagSetup(vehicle, setups){
    setups.forEach(val => {
      if(vehicle.provider == val.service){
        return val;
      }
    });
    return  null;
  }
  refresh(){
    if(this.vehicle){
      this.vehicleProvider.getVehicleDetail(this.vehicle.id)
      .then(val => {
        if(val.data && val.data.length==1){
          this.vehicle = val.data[0]
        }
      })
    }
  }
  refreshVehicle(){
    this.refresh()
  }
  openUpdateVehicle(event){
    event.stopPropagation()
    this.navCtrl.push(AddVehiclePage, {
      parent : this,
      data: this.vehicle,
      providers: this.providers
    });
  }
  openTagPage(){
    this.navCtrl.push(VehicleTagPage, {
      vehicle : this.vehicle,
      setups: this.providers,
      parent: this
    });
  }
  getSmartLocksData() {
    this.smartLockProvider.getSmartLocks().then((val: any) => {
      console.log("get smart lock call" + val);
      if (val.status == 'success') {
        this.vehSmartLocks = val.data;
      }
    }).catch(error => {
    })
  }

  setVehicleAccess(data){
    if(data && data.enable && data.enable==true){
      data.enable = 1;
    }else if(data && data.enable== false){
      data.enable = 0 ;
    }
    this.smartLockProvider.updateVehicleAccessStatus(data).then((val:any)=>{
      if(val.status == 'success'){
        setTimeout(() => {
          this.toast.presentToast(val.message);
          this.getSmartLocksData();
        },6000);
      }else{
        this.toast.presentToast(val.message);
        this.getSmartLocksData();
      }
    });
  }

  notifyEnabled(notifyTo: string){ // 
    if(notifyTo && notifyTo != "[]"){
      try{
        console.log(notifyTo);
        this.extra.getUserDetails().then(val => {
          JSON.parse(notifyTo).forEach(id => {
            if(val.id == id){
              this.isNotifyEnabled = true;
            }
          });
        });
      }catch(e){
        this.isNotifyEnabled = false;
      }
    }
  }

  toggleNotification(){
    if(this.isNotifyEnabled){
      let data  = {
        id : this.vehicle.id,
        is_subscribed : 0
      }
      this.vehicleProvider.updateVehicleSubscription(data)
        .then(val => {
        if(val.status == "success"){
          this.isNotifyEnabled = false;
          this.navParams.get('parent').refreshVehicle()
          ;
        }

        this.toast.presentToast("Disable");
      });
    } else {
      let data  = {
        id : this.vehicle.id,
        is_subscribed : 1
      }
      this.vehicleProvider.updateVehicleSubscription(data)
      .then(val => {
        if(val.status == "success"){
          this.isNotifyEnabled = true;
          this.navParams.get('parent').refreshVehicle()
          ;
        }

        this.toast.presentToast("Enabled");
      });
    }
  }

  accesslog(){
    this.navCtrl.push(VehicleAccessLogPage, {
      vehicleNo : this.vehicle.vehicle_no.toUpperCase(),
      id: this.vehicle.id,
    });
  }
  toastData(data){
    this.toast.presentToast(data);
  }
    getObject(s : string){
    return JSON.parse(s);
  }

  vehicleTagAutoLock(vehicle){
    vehicle.tag_lock = (vehicle.tag_lock)?false:true;
    this.vehicleProvider.vehicleTagAutoLock(vehicle)
      .then(val => {
        this.refresh()
        this.navParams.get('parent').refreshVehicle()
        ;
        
        let message = "Success";
        if(val.data && val.data.message){
          message  = val.data.message;
        }else if (val && val.message){
          message  = val.message;
        }
        this.toast.presentToast(message);
      });
  }

  confDeleteVehicle(){
    const confirm = this.alertCtrl.create({
      title: 'Delete vehicle ?',
      message: 'Vehicle '+this.vehicle.vehicle_no+'. All the logs and tag associated will also get deleted. This action cannot be reverted, do you want to continue ?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            // console.log('Disagree clicked');
          }
        },
        {
          text: 'Delete',
          cssClass:'danger',
          handler: () => {
            this.deleteVehicle()
          }
        }
      ]
    });
    confirm.present();
  }
  deleteVehicle(){
    this.vehicleProvider.deleteVehicleDetail(this.vehicle)
    .then(val => {
      this.navParams.get('parent').refreshVehicle()
      this.navCtrl.pop()
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VehicleDetailPage');
  }


  toggleGroup(view: any) {
    console.log(view);
    this.viewAccordion[view] = !this.viewAccordion[view]
  }
}



// WEBPACK FOOTER //
// ./src/pages/vehicle-detail/vehicle-detail.ts